import { apiClient } from './apiClient';

export const redirectToAuditor = async (): Promise<void> => {
  const response = await apiClient.post('/auth/sso-token', { target: 'auditor' });
  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to generate SSO token');
  }

  window.location.href = result.redirectUrl;
};
